import * as React from "react"
import { Auth0Provider } from "@auth0/auth0-react"

const Auth0AvailabilityContext = React.createContext(true)

export function useAuth0Availability() {
  return React.useContext(Auth0AvailabilityContext)
}

// Auth0 requires a secure origin (HTTPS or localhost). Skip when not secure to avoid runtime error.
function isSecureOrigin() {
  if (typeof window === "undefined") return true
  return window.isSecureContext === true
}

// Config from window (injected by gatsby-ssr) so client always has it; fallback to process.env
function getConfig() {
  if (typeof window !== "undefined" && window.__AUTH0_CONFIG__) {
    return window.__AUTH0_CONFIG__
  }
  return {
    domain: process.env.GATSBY_AUTH0_DOMAIN,
    clientId: process.env.GATSBY_AUTH0_CLIENT_ID,
    audience: process.env.GATSBY_AUTH0_AUDIENCE || undefined,
  }
}

export const Auth0Wrapper = ({ children }) => {
  const config = getConfig()
  const { domain, clientId, audience } = config
  if (!domain || !clientId) {
    return <>{children}</>
  }

  if (!isSecureOrigin()) {
    return (
      <Auth0AvailabilityContext.Provider value={false}>
        {children}
      </Auth0AvailabilityContext.Provider>
    )
  }

  const redirectUri =
    typeof window !== "undefined"
      ? `${window.location.origin}/callback`
      : "https://infict.com/callback"

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: audience || undefined,
        scope: "openid profile email roles offline_access",
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  )
}

export default Auth0Wrapper
